export const COMMUNICATION_TYPE_OPTIONS = [
  {
    value: 'L',
    text: 'Landline Phone',
  },
  {
    value: 'F',
    text: 'Fax',
  },
  {
    value: 'E',
    text: 'Email',
  },
  {
    value: 'M',
    text: 'Mobile Phone',
  },
] as const;

export type CommunicationType =
  | (typeof COMMUNICATION_TYPE_OPTIONS)[number]['value']
  | '';
